import React from 'react';

const ClientsSlider = () => {
  // Logos de clientes de ejemplo en escala de grises
  const clients = [
    { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg' },
    { name: 'Google', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg' },
    { name: 'Amazon', logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg' },
    { name: 'IBM', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg' },
    { name: 'Oracle', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/50/Oracle_logo.svg' },
    { name: 'SAP', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg' },
    { name: 'Cisco', logo: 'https://upload.wikimedia.org/wikipedia/commons/6/64/Cisco_logo.svg' },
    { name: 'Intel', logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7d/Intel_logo_%282006-2020%29.svg' },
  ];

  return (
    <section className="py-20 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-gray-900">Respaldo </span>
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">Tecnológico de Clase Mundial</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-cyan-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Infrasetructura y soporte garantizado por las marcas líderes del mercado.
          </p>
        </div>

        {/* Slider Container */}
        <div className="relative">
          <div className="flex animate-scroll-infinite">
            {/* First set of logos */}
            {clients.map((client, index) => (
              <div
                key={`client-1-${index}`}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
                style={{ width: '150px', height: '80px' }}
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-w-full max-h-full object-contain opacity-90 md:grayscale md:opacity-60 md:hover:opacity-100 md:hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
            {/* Duplicate for infinite scroll */}
            {clients.map((client, index) => (
              <div
                key={`client-2-${index}`}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
                style={{ width: '150px', height: '80px' }}
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="max-w-full max-h-full object-contain opacity-90 md:grayscale md:opacity-60 md:hover:opacity-100 md:hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSlider;
